import { ActionKind } from '@dynamic/ui';
import { useMemo } from 'react';
import { generatePath } from 'react-router';

import { MoreItem } from '#/service/config/more.types';
import { InternalPageId } from '#/service/constants/menu';
import { destinationRoutes, Path } from '#/service/routes';

interface Props {
  settingsToUse: MoreItem[];
}

export const useMoreMenuRoutes = ({ settingsToUse }: Props) => {
  const moreMenuRoutes = useMemo(() => {
    return (
      settingsToUse
        ?.map(({ key = '', action }) => {
          if (!action) {
            return generatePath(Path.Settings, { settingId: key });
          }

          const { kind, parameters: { view, pageId } = {} } = action;

          if (view && kind === ActionKind.NavigateInternal) {
            return destinationRoutes[view as InternalPageId] ?? null;
          }

          if (pageId && kind === ActionKind.NavigatePage) {
            return generatePath(Path.Page, { pageId });
          }

          return null;
        })
        .filter(Boolean) ?? []
    );
  }, [settingsToUse]);

  return {
    moreMenuRoutes,
  };
};
